import React, { useEffect, useState } from 'react'
import {  IInformacionGeneral } from '../collaboratorCreateView'
import { ComboBox, IComboBoxOption, Icon, Spinner } from '@fluentui/react';
import { IorganizationLevels } from '../../../../system/AuthenticationSystem';
import Environment from '../../../../lib/Environment';
import { t } from 'i18next';

interface IListtransform {
  key: string;
  text: string;
}

interface IvalueNodeGe extends IorganizationLevels {
  filterValuenode: IComboBoxOption[];
  valuenode: IComboBoxOption[];
  value: string;
  newValue:IComboBoxOption;
  nivel:string;
}

function OrganizationalStructure({ system, errors, register, setValue, watch, changeBlockUI }: IInformacionGeneral) {
  const valueEdingManagement = new Environment().EditingManagement() || "1";

  const [organizationLev, setOrganizationLev] = useState<IvalueNodeGe[]>([]);
  const [levels , setLevels] = useState<IorganizationLevels[] | undefined>();

  const [cargo, setCargo] = useState<IListtransform[]>([]);
  const [cargofilter, setCargofilter] = useState<IListtransform[]>([]);
  const [newcargo, setNewcargo] = useState<IListtransform>({ key: "9999", text: "" });
  const [loading,setLoading] = useState<boolean>(false);

  const cargoList = async () => {
    if (!system) return;
    try {
      changeBlockUI?.(true)
      const response = await system.listCargo();
      const directions = response.map((item) => {
        const obejts = {
          key: item.cargo_id,
          text: item.cargo_nombre,
        }
        return obejts
      });
      setCargo([...directions, newcargo]);
      setCargofilter([...directions, newcargo]);
    } catch (error) {
      console.log(error)
    } finally {
      changeBlockUI?.(false)
    }
  }

  const onInputValueChangeCargo = (text: string) => {
    setNewcargo({ ...newcargo, text });
    let filtrado = cargo.filter(c => c.text.toLowerCase().includes(text.toLowerCase()));
    setCargofilter(filtrado);
  }

  const onChangeCargoo = (event, option) => {
    let data = option;
    if (option === undefined && newcargo.text !== "") {
      data = newcargo;
    }
    setValue("cargo", data);
  }

  const cleantnodes = (nio_id: string)=>{
    const selectedLevelNumber = parseInt(nio_id, 10);
    const deleteValueNode = organizationLev.map((item,index)=>{
      const itemLevel = parseInt(item.nio_id, 10);
      if(itemLevel > selectedLevelNumber){
        setValue(`Estructura Organizacional[${index}].${item.nio_nombre}`, '');
      return { 
        ...item,
        newValue:{ key: "9999", text: "" },
        filterValuenode:[],
        valuenode : [],
        value : ''
      }
      };
      return item;
    });
    return(deleteValueNode);
    ;
  }

  const OnchangeValueNodeLev =async (option:IComboBoxOption | undefined ,nio_id: string,newValue: IComboBoxOption,nio_nombre:string,nivel:string,index:number)=>{
    console.log(option,nio_id,nio_nombre,nivel );
    let data:IComboBoxOption | undefined = option;
    if(option === undefined && newValue.text !== ""){
      data = newValue
    }
    setValue(`Estructura Organizacional[${index}].${nio_nombre}`,data);
    let setValueSelect = cleantnodes(nio_id);
        setValueSelect =  setValueSelect.map((item)=>{
      if(nio_id === item.nio_id){
       return{
        ...item,
        value : data?.text || ''
      }
      };
      return item;
    })

    if(option !== undefined ){
      setLoading(true);
      const optionParcedata = (option.key) as string;
      const response = await system!.getselcts(nivel,optionParcedata);
      const directions :IComboBoxOption[]= response.map((item)=>{
       return {
        key:item.nor_id,
        text:item.nor_nombre,
        nor_nivel:item.nor_nivel,
        nor_padre:item.nor_padre
       }
      });

      setValueSelect = setValueSelect.map((item)=>{
        if(nivel === item.nio_id){
          return{
         ...item,
         valuenode :directions || [],
         filterValuenode : directions || []
         }
        };
        return item;
      });
    }
    setOrganizationLev(setValueSelect);
    setLoading(false)
  };

  const OnchangeValueNodeLevFilter = (text:string,nio_id: string,newValue: IComboBoxOption,nio_nombre:string,nivel:string)=>{
    setOrganizationLev(organizationLev.map((i)=>{
         if(i.nio_id === nio_id){
           return{
            ...i,
            newValue : {...newValue,text: text.trimStart()}, // Evitar los espacios en blanco al inicio cuando el usuario escriba
           filterValuenode : i.valuenode.filter(d=> d.text.trimStart().toLowerCase().includes(text.trimStart().toLowerCase())) // Evitar los espacios en blanco al inicio cuando el usuario escriba
          }
         }
         return i;
    }));
  }

  const getNextLevel = (levels:  IorganizationLevels[] , currentLevelId: string)=> {
    const current = Number(currentLevelId);
    const sortedLevels = levels.slice().sort((a, b) => Number(a.nio_id) - Number(b.nio_id));
    return sortedLevels.find(level => Number(level.nio_id) > current);
  };

  const getOrganizationLevels = async () => {
    setLoading(true);
    changeBlockUI?.(true)
    const response = await system?.getselcts();
    const levels = await system?.getOrganizationLevels();
    const parcedata = response?.map((item) => ({ key: item.nor_id, text: item.nor_nombre, nor_nivel: item.nor_nivel, nor_padre: item.nor_padre }));
    setLevels(levels);
    if (!levels) return;
    const resultnodo = levels.map(({ nio_id, nio_nombre, nio_nombre_tec },index) => {
      /* 
        Si el id es 1 del nivel entonces significa que es el nivel padre requerido
        Punto de mejora: Se recomienda colocar una columa en la tabla de niveles que diferencie el primer nivel con los demas
       */
      register( `Estructura Organizacional[${index}].${nio_nombre}` , { required: nio_id === '1' });
      const nodoEncontrado = getNextLevel(levels,nio_id);
      return {
        nio_id,
        nio_nombre,
        nio_nombre_tec,
        valuenode: nio_id === '1' ? (parcedata || []) : [],
        filterValuenode:nio_id === '1' ? (parcedata || []) : [],
        value: "",
        newValue: { key: "9999", text: "" },
        nivel: nodoEncontrado ? nodoEncontrado.nio_id : ''
      };
    });
    register('cargo', { required: true });
    setOrganizationLev(resultnodo);
    setLoading(false);
    changeBlockUI?.(false)
  }

/*   const typeUseReque = ()=>{
    if(!!(watch('selecusuarios')?.text === undefined))return;
 
    if(watch('selecusuarios')?.text === 'Directivo' && levels?.length){
       levels.forEach((item,index)=>{
        if(index!== 0){
          register( `Estructura Organizacional[${index}].${item.nio_nombre}` , { required: false });
        }
       })  
    }else if(levels?.length ){
      levels.forEach((item,index)=>{
        if(index!== 0){
          register( `Estructura Organizacional[${index}].${item.nio_nombre}` , { required: true });
        }
       }) 
    }
  } */

  useEffect(() => {
    getOrganizationLevels();
    cargoList();
  }, []);

/*   useEffect(()=>{
    typeUseReque();
  },[watch('selecusuarios')]) */

  return (
    <div className="form_informacion_generalss">
      <p className="titulo_form_create">
        <Icon iconName="Org" style={{ fontSize: "25px" }} />
        {t('Estructura Organizacional')}
      </p>
      <div className="cuerpo_izquierdo_form" style={{ position: 'relative' }}>
        {
          organizationLev.map(({ nio_id, nio_nombre, nio_nombre_tec, filterValuenode, valuenode, value,newValue,nivel },index) => {

            return (
              <>
                <ComboBox
                  key={nio_id}
                  allowFreeInput={true}
                  className="label_reusable"
                  placeholder={t("Seleccione la ") + t(nio_nombre)}
                  label={t(nio_nombre)}
                  options={filterValuenode}
                  text={value || undefined}
                  onChange={(_,option)=>OnchangeValueNodeLev(option,nio_id,newValue,nio_nombre,nivel,index) }
                  onInputValueChange={(text)=>OnchangeValueNodeLevFilter(text,nio_id,newValue,nio_nombre,nivel)}
                  styles={{ root: { width: "302px" } }}
                  allowFreeform={valueEdingManagement === "1"? true:false}
                  selectedKey={nio_id} 
                />
                {errors["Estructura Organizacional"]?.[index]?.[nio_nombre] && <span className="error_stilos_Organizacional">{t(nio_nombre)} {t('no puede ser vacío.')}</span>}
              </>
            )
          })
        }
        {(!!organizationLev.length) && <>
          <ComboBox
            className="label_reusable"
            placeholder={t("Escribir el cargo")}
            label={t('Cargo')}
            options={cargofilter}
            styles={{ root: { width: "170px" } }}
            onChange={(event, option) => onChangeCargoo(event, option)}
            onInputValueChange={onInputValueChangeCargo}
            text={
              cargo.some(item => item.text.toLowerCase().includes(newcargo.text.toLowerCase())) ? undefined : newcargo.text}
            allowFreeform
          />
          {errors.cargo && <span className="error_stilos_Organizacional">{t('El cargo no puede ser vacío.')}</span>}
        </>}
        {
          (loading) &&
          <div className='spinner-overlay-create-col'><Spinner /></div>
        }
      </div>
    </div>
  )
}

export default OrganizationalStructure;
